import * as React from 'react';
import { PCImage } from 'app/design/primitives/image';
import { images } from 'app/design/images';

export default function NotificationSuperPartageur({ width = 60, height = 72 }: { width?: number; height?: number }) {
  return <PCImage height={height} source={images.notifSuperPartageur} width={width} />;
}
